module.exports = __webpack_public_path__ + "img/card_teaching_eval.44482d64.png";